import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { sectionPath } from './settings-sections';
import { useCanReadSection } from './useSettingsAccess';

const CONNECTIONS = { group: 'connections', id: 'providers' } as const;

/**
 * "Connections → Providers", as a link for a role that may open it and as
 * plain words for one that may not (DEV-140: Treasury is read by roles that
 * cannot open the provider connections).
 */
export function ConnectionsLink(): JSX.Element {
  const label = 'Connections → Providers';
  return useCanReadSection(CONNECTIONS)
    ? <Link component={RouterLink} to={sectionPath(CONNECTIONS)}>{label}</Link>
    : <>{label}</>;
}
